import React from 'react';
import MuiInputLabel, { InputLabelProps as MuiInputLabelProps } from '@mui/material/InputLabel';

/**
 * Design System InputLabel
 * Adds support for color variants.
 */
export interface InputLabelProps extends MuiInputLabelProps {
  colorVariant?: string;
}

const DSInputLabel = React.forwardRef<HTMLLabelElement, InputLabelProps>(
  function DSInputLabel({ colorVariant = 'default', className = '', ...props }, ref) {
    let variantClass = '';
    if (colorVariant === 'white') {
      variantClass = 'ds-inputlabel-white';
    }
    // Add more variants as needed
    return (
      <MuiInputLabel ref={ref} className={`${variantClass} ${className}`} {...props} />
    );
  }
);

export default DSInputLabel;
